import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { COMPANY, generalWhatsAppUrl } from "@/data/products";

export default function Contact() {
  return (
    <section id="contact" className="scroll-mt-20 bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid gap-12 lg:grid-cols-2">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze-dark">
              Contact
            </p>
            <h2 className="mt-3 font-display text-3xl font-semibold text-charcoal sm:text-4xl">
              Let’s Find the Right Gear
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-charcoal/70 sm:text-base">
              Reach us on WhatsApp, by email or by phone for product details,
              availability and purchasing enquiries.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <a
                href={generalWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#1fa855] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#178a45]"
                data-testid="contact-whatsapp-button"
              >
                <MessageCircle className="h-4 w-4" aria-hidden="true" />
                WhatsApp Us
              </a>
              <a
                href={`mailto:${COMPANY.email}`}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-charcoal/25 px-6 py-3 text-sm font-semibold text-charcoal transition-colors hover:border-forest hover:text-forest"
                data-testid="contact-email-button"
              >
                <Mail className="h-4 w-4" aria-hidden="true" />
                Email Us
              </a>
              <a
                href={`tel:${COMPANY.phoneIntl}`}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-charcoal/25 px-6 py-3 text-sm font-semibold text-charcoal transition-colors hover:border-forest hover:text-forest"
                data-testid="contact-call-button"
              >
                <Phone className="h-4 w-4" aria-hidden="true" />
                Call {COMPANY.phoneDisplay}
              </a>
            </div>
          </div>

          <div className="rounded-2xl border border-charcoal/10 bg-cream p-6 sm:p-8" data-testid="contact-details-card">
            <h3 className="font-display text-lg font-semibold text-charcoal">{COMPANY.name}</h3>
            <p className="mt-1 text-sm text-charcoal/65">SSM: {COMPANY.ssm}</p>
            <dl className="mt-6 space-y-5 text-sm">
              <div className="flex gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-bronze-dark" aria-hidden="true" />
                <div>
                  <dt className="font-semibold text-charcoal">Business Address</dt>
                  <dd className="mt-1 leading-relaxed text-charcoal/70">{COMPANY.address}</dd>
                </div>
              </div>
              <div className="flex gap-3">
                <Mail className="mt-0.5 h-5 w-5 shrink-0 text-bronze-dark" aria-hidden="true" />
                <div>
                  <dt className="font-semibold text-charcoal">Email</dt>
                  <dd className="mt-1">
                    <a href={`mailto:${COMPANY.email}`} className="text-forest underline-offset-2 hover:underline">
                      {COMPANY.email}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex gap-3">
                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-bronze-dark" aria-hidden="true" />
                <div>
                  <dt className="font-semibold text-charcoal">Telephone</dt>
                  <dd className="mt-1">
                    <a href={`tel:${COMPANY.phoneIntl}`} className="text-forest underline-offset-2 hover:underline">
                      {COMPANY.phoneDisplay} ({COMPANY.phoneIntl})
                    </a>
                  </dd>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
